import { render, staticRenderFns } from "./DialogCurvasProdutos.vue?vue&type=template&id=d9c5f316"
import script from "./DialogCurvasProdutos.vue?vue&type=script&lang=js"
export * from "./DialogCurvasProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports